// app/javascript/controllers/editor_controller.js
import { Controller } from "@hotwired/stimulus"
import { Editor } from "@tiptap/core"
import StarterKit from "@tiptap/starter-kit"
import { Underline } from "@tiptap/extension-underline"
import { TextStyle } from "@tiptap/extension-text-style"
import { Color } from "@tiptap/extension-color"
import { Link } from "@tiptap/extension-link"

export default class extends Controller {
  static targets = ["editor", "input"]

  connect() {
    this.editor = new Editor({
      element: this.editorTarget,
      extensions: [
        StarterKit,
        Underline,
        TextStyle,
        Color,
        Link
      ],
      content: this.editorTarget.innerHTML,  // inizializza con il div

      onUpdate: ({ editor }) => {
        this.inputTarget.value = editor.getHTML()
      }
    })

    // 🔥 forza sync al submit
    this.form = this.element.closest("form")
    this.form?.addEventListener("submit", this.syncBeforeSubmit)
  }

  disconnect() {
    this.form?.removeEventListener("submit", this.syncBeforeSubmit)
    this.editor?.destroy()
  }

  syncBeforeSubmit = () => {
    this.inputTarget.value = this.editor.getHTML()
  }


  bold() { this.editor.chain().focus().toggleBold().run() }
  italic() { this.editor.chain().focus().toggleItalic().run() }
  underline() { this.editor.chain().focus().toggleUnderline().run() }

  bullet() { this.editor.chain().focus().toggleBulletList().run() }
  ordered() { this.editor.chain().focus().toggleOrderedList().run() }

  color(e) {
    this.editor.chain().focus().setColor(e.target.value).run()
  }

  size(e) {
    this.editor.chain().focus().setMark("textStyle", { fontSize: e.target.value }).run()
  }

  link() {
    const url = prompt("URL")
    if (!url) return
    this.editor.chain().focus().setLink({ href: url }).run()
  }
}
